import * as React from 'react';
import {Component, ReactElement} from 'react';
import {HashRouter, Route, Switch} from 'react-router-dom';
import {AuthSignIn} from './sign-in';
import {AuthSignUp} from './sign-up';
import {AuthSignUpUdacity} from './sign-up-udacity';
import {UserForgotPassword} from './forgot-password';
import {trackOnce} from '../../utils/tracker';
import {LANDED, PROMO_CODE, REF_CODE} from '../../utils/config';

const trackLanded = () => (
  LANDED && trackOnce('landed', {'ref-code': REF_CODE, 'promo': PROMO_CODE, page: 'home'})
);

export class AuthRouter extends Component<{}> {
  public componentDidMount(): void {
    trackLanded();
  }

  public render(): ReactElement<HashRouter> {
    return (
      <HashRouter>
        <Switch>
          <Route path={'/sign-in'} component={AuthSignIn}/>
          <Route path={'/sign-up'} exact component={AuthSignUp}/>
          <Route path={'/sign-up/udacity'} component={AuthSignUpUdacity}/>
          <Route path={'/forgot-password'} component={UserForgotPassword}/>
        </Switch>
      </HashRouter>
    );
  }
}
